// extracted by mini-css-extract-plugin
module.exports = {"paper":"paper-39tPN","groupTitle":"groupTitle-1Rc-p","groupWrapper":"groupWrapper-1nty1","active":"active-3jr2F","reasons":"reasons-3l2lq","reason":"reason-1Iewk"};